import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, color = "var(--forest)" }) => (
  <p className="text-xs font-semibold uppercase mb-2" style={{ color }}>{children}</p>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.08] ${className}`}>{children}</h2>
);

export const Section = ({ id, children, className = "", testid }) => (
  <section id={id} data-testid={testid} className={`px-5 sm:px-8 py-20 sm:py-28 ${className}`}>
    <div className="max-w-6xl mx-auto">{children}</div>
  </section>
);
